require('normalize.css/normalize.css');
require('./scss/boy.scss');
require('./blog');

import 'slick-carousel';
import 'slick-slider';
import 'bootstrap/js/dist/util';
import 'jquery-visible';
import 'isotope-layout';
import 'isotope-fit-columns';

import {initModals} from './modals';
import {initSliders} from './sliders';
import {initNavigation} from './navigation';
import {initPersons} from './persons';
import {initHeaderColor} from './headercolor';
import {initSectionScroller} from './scrolltosection';
import {initReferenceList} from './referencelist';


$(document).ready(function () {
  initSliders();
  initModals();
  initNavigation();
  initPersons();
  initHeaderColor();
  initSectionScroller();
  initReferenceList();
});



